<app-wb-app-overlay
  *ngIf="static; else chatGpt"
  [static]="static"
  [appIcon]="appIcon$ | async"
></app-wb-app-overlay>

<ng-template #chatGpt>
  <div class="app-container" [class.selected]="selected$ | async">
    <app-items-canvas-interaction-bar
      *ngIf="!static"
      [showLockButton]="true"
      [showPrivacyButton]="true"
      [showDuplicateButton]="false"
      [showFullScreenButton]="false"
      [showRefreshButton]="false"
      [itemModel]="ItemModel.Chat_GPT"
      [selected]="selected$ | async"
      [id]="state.uid"
      [title]="formattedTitle$ | async"
      [isPrivate]="state.isPrivate"
      [interactionsLocked]="state.interactionsLocked"
      [appIcon]="appIcon$ | async"
      (screenshotTaker)="takeScreenshot()"
      (interactionsLockChanged)="onInteractionsLockChanges($event)"
      (privacyChanged)="onPrivacyChanged($event)"
      (deleteItem)="deleteItem.emit()"
      [isSpaceHost]="spaceRepo.isCurrentUserHost$ | async"
      [ownerId]="state.ownerId"
      [style.pointer-events]="'none'"
    ></app-items-canvas-interaction-bar>

    <div class="chatgpt-container" #chatGPTContainer>
      <div
        infiniteScroll
        [infiniteScrollUpDistance]="1"
        [infiniteScrollThrottle]="200"
        [scrollWindow]="false"
        [immediateCheck]="false"
        [infiniteScrollDisabled]="infiniteScrollDisabled"
        (scrolledUp)="handleScrollUp()"
        class="conversation-container align-self-stretch"
      >
        <app-gpt-conversation-item
          *ngFor="let item of data$ | async; let i = index; trackBy: trackMessage"
          [message]="item"
          [isCurrentUser]="isCurrentUser(item.poster._id)"
        ></app-gpt-conversation-item>
      </div>
      <div class="bot-writing" *ngIf="botWriting$ | async">
        {{ typingMessage }}
      </div>
      <div class="input-container">
        <textarea
          appTextareaAutoResize
          [readonly]="(shouldDisableInteractions$ | async) == true"
          [minRows]="1"
          [maxRows]="3"
          [formControl]="question"
          (keydown.enter)="handleSendMessage($event)"
          [placeholder]="placeholder"
          [rows]="1"
          (keydown)="handleKeyDown($event)"
          [ngStyle]="{
            cursor: (shouldDisableInteractions$ | async) ? 'not-allowed' : 'auto'
          }"
        ></textarea>
        <div
          [ngbTooltip]="disabledButtonTooltip"
          [placement]="'top'"
          [disableTooltip]="tooltipDisabled$ | async"
        >
          <button
            (click)="handleSendMessage($event)"
            [disabled]="
              this.question.invalid ||
              this.inProgress ||
              (botWriting$ | async) ||
              (shouldDisableInteractions$ | async)
            "
            mat-icon-button
          >
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #disabledButtonTooltip>
  <app-tooltip
    [text]="
      'Your message can\'t be sent right now as GPT is already answering another question'
        | translate
    "
    [arrow]="'bottom'"
    [createNewLine]="true"
  ></app-tooltip>
</ng-template>
